<!-- Dialog title and close button -->
<div class="bottom-shadow dialog-title-padding">
    <div class="page-title">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
            <mat-icon mat-dialog-close class="cursor">keyboard_backspace</mat-icon>
            <h3 class="lato-regular">
                Change Password</h3>
        </div>
        <div>
            <mat-icon mat-dialog-close class="cursor">close</mat-icon>
        </div>
    </div>
</div>


<!-- Middle section of the dialog -->
<div class="middle-sec dialog-middle">
    <form [formGroup]="passwordForm">
        <div class="root">
            <!-- Current Passsword -->
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>Current Password</mat-label>
                <input matInput formControlName="currentPassword" [type]="hideCurrent ? 'password' : 'text'">
                <button mat-icon-button matSuffix (click)="toggleHideCurrent()">
                    <mat-icon>{{ hideCurrent ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
                <div class="custom-message"
                    *ngIf="passwordForm.get('currentPassword')?.invalid && (passwordForm.get('currentPassword')?.touched || passwordForm.get('currentPassword')?.dirty)">
                    <ng-container *ngIf="passwordForm.get('currentPassword')?.hasError('required')">
                        Current Password is required
                    </ng-container>
                </div>
            </mat-form-field>
            <!-- New Password -->
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>New Password</mat-label>
                <input matInput formControlName="newPassword" [type]="hideNew ? 'password' : 'text'">
                <button mat-icon-button matSuffix (click)="toggleHideNew()">
                    <mat-icon>{{ hideNew ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
                <div class="custom-message"
                    *ngIf="passwordForm.get('newPassword')?.invalid && (passwordForm.get('newPassword')?.touched || passwordForm.get('newPassword')?.dirty)">
                    <ng-container *ngIf="passwordForm.get('newPassword')?.hasError('required')">
                        New Password is required
                    </ng-container>
                    <ng-container *ngIf="passwordForm.get('newPassword')?.errors?.['minlength']">
                        Password must be at least {{
                        passwordForm.get('newPassword')?.errors?.['minlength']?.requiredLength }} characters long
                    </ng-container>
                    <ng-container *ngIf="passwordForm.get('newPassword')?.hasError('pattern')">
                        Password must contain at least one uppercase letter, one lowercase letter, and one digit
                    </ng-container>
                </div>
            </mat-form-field>
            <!-- Re Password -->
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>Re-enter Password</mat-label>
                <input matInput formControlName="confirmPassword" [type]="hideConfirm ? 'password' : 'text'">
                <button mat-icon-button matSuffix (click)="toggleHideConfirm()">
                    <mat-icon>{{ hideConfirm ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
                <div class="custom-message"
                    *ngIf="passwordForm.get('confirmPassword')?.invalid && (passwordForm.get('confirmPassword')?.touched || passwordForm.get('confirmPassword')?.dirty)">
                    <ng-container *ngIf="passwordForm.get('confirmPassword')?.hasError('required')">
                        Confirm Password is required
                    </ng-container>
                    <ng-container *ngIf="passwordForm.get('confirmPassword')?.errors?.['passwordMismatch']">
                        Passwords do not match
                    </ng-container>
                </div>
            </mat-form-field>
        </div>
    </form>
</div>

<!-- Bottom section of the dialog -->
<div class="bottom-padding top-shadow">
    <div fxlayout="row" fxLayoutAlign="end">
        <button mat-raised-button class="cancel" type="button" mat-dialog-close>Cancel</button>
        <button mat-raised-button class="text-white bg-primary" type="submit" (click)="submitForm()">
            <span *ngIf="!loading">Save & Close</span>
            <span *ngIf="loading" [ngClass]="{ spinner: loading, 'add-button': loading }">
            </span>
        </button>
    </div>
</div>